import {Competitor, CustomFieldValue, RaceAdditionalPricingItem, RaceCommercialItem} from "@model";

export class CompetitorRegistrationDto {
  userId?: number;
  couponCode?: string;
  discountId?: number;
  customFieldValues?: Array<CustomFieldValue>;
  raceAdditionalPricingItems?: Array<RaceAdditionalPricingItem>;
  raceCommercialItem?: RaceCommercialItem;
  firstName?: string;
  lastName?: string;
  birthday?: Date;
  placeOfResidence?: string;
  address?: string;
  city?: string;
  mobilePhone?: string;
  emergencyPhone?: string;
  identityCardNumber?: string;
  identityCardIssuer?: string;
  identityExpiration?: Date;
  licence?: string;
  comment?: string;
  chipNumber?: string;
  bestTime?: string;
  club?: string;
  transport?: number;
  meal?: number;
  tShirt?: number;
  email?: string;
  receiptEmail?: string;
  country?: string;
  nationality?: number;
  gender?: number;
  zip?: string;
  nickname?: string;
  receiveReceipt?: boolean;
  discipline?: number;
  teamName?: string;

  startNumber?: string;
  startBlock?: number;
  presentAtStart?: boolean;

  constructor() {
  }

  static dtoToCompetitor(dto: CompetitorRegistrationDto): Competitor {
    const competitor = new Competitor();

    competitor.userId = dto.userId;
    competitor.customFieldValues = dto.customFieldValues;
    competitor.firstName = dto.firstName;
    competitor.lastName = dto.lastName;
    competitor.birthday = dto.birthday;
    competitor.placeOfResidence = dto.placeOfResidence;
    competitor.address = dto.address;
    competitor.placeOfResidence = dto.city;
    competitor.mobilePhone = dto.mobilePhone;
    competitor.emergencyPhone = dto.emergencyPhone;
    competitor.identityCardNumber = dto.identityCardNumber;
    competitor.identityCardIssuer = dto.identityCardIssuer;
    competitor.identityCardExpires = dto.identityExpiration;
    competitor.licence = dto.licence;
    competitor.comment = dto.comment;
    competitor.chipNumber = dto.chipNumber;
    competitor.bestTime = dto.bestTime;
    competitor.club = dto.club;
    competitor.transport = dto.transport;
    competitor.meal = dto.meal;
    competitor.tshirt = dto.tShirt;
    competitor.email = dto.email;
    competitor.country = dto.country;
    competitor.zip = dto.zip;
    competitor.fullName = dto.firstName + " " + dto.lastName;
    competitor.sex = dto.gender;
    competitor.discipline = dto.discipline;
    competitor.nationality = dto.nationality;
    return competitor;
  }
}

